export class SmartTable {

    constructor() {
        this.displayedItems = [];
    }

    get selectedItems() {
        return this.displayedItems.filter((item) => item.isSelected);
    }

    get selectedIds() {
        return this.selectedItems.map((item) => item.id);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/smart-table/smart-table.model.js